module.exports = __webpack_public_path__ + "static/media/foee-01.4c302617.png";


//////////////////
// WEBPACK FOOTER
// ./src/foee-01.png
// module id = 241
// module chunks = 0